import { defaultEstado, EstadoProps } from "./EstadoInterface";

//Definición de defaults

export const defaultMunicipio: MunicipioProps = {
    idMunicipio:        0,
    clave:              '',
    descripcion:        '',  
    idEstado:           0,
    estado:             defaultEstado,
    activo:             false,
}

// Creación de interfaces

export interface MunicipioProps{
    idMunicipio:    number;
    clave:          string;
    descripcion:    string;
    activo:         boolean;
    idEstado:       number;
    estado?:        EstadoProps;
}
